import s from './ErrorMessage.module.scss';
import {TErrorMessageProps} from "@/app/[locale]/common/components/ErrorMessage/types";

export const ErrorMessage = ({ message }: TErrorMessageProps) => {
    return (
        <p role={'alert'} className={s.error}>
            { message }
        </p>
    );
};